// Shared avatar-fallback initials for staff/people.
//
// Returns 2 uppercase initials (first name + last name) so people who share a
// first name stay distinguishable (e.g. "Lisa East" -> "LE", "Lulu Mewards" ->
// "LM"). Falls back to a single initial for one-word names, and "?" when there
// is nothing usable.
//
// Accepts any staff shape used across the app:
//  - object with FirstName / LastName
//  - object with FullName / Name / StaffName
//  - a plain full-name string (e.g. "Lisa East")
export default function getStaffInitials(input) {
  if (!input) return "?";

  let first = "";
  let last = "";
  let name = "";

  if (typeof input === "string") {
    name = input;
  } else {
    first = (input.FirstName || "").trim();
    last = (input.LastName || "").trim();
    name = input.FullName || input.Name || input.StaffName || "";
  }

  if (first && last) return (first[0] + last[0]).toUpperCase();

  const parts = (first || last || name).trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (parts[0]?.[0] || "?").toUpperCase();
}
